module.exports = __webpack_public_path__ + "media/images/tutorial_header_pc2-01-2942932c363ed44fc428aee13737f71b.png";